interface EmptyValueProps {
  label?: string
}

export function EmptyValue({ label = 'Not specified' }: EmptyValueProps) {
  return (
    <>
      <span aria-hidden="true">—</span>
      <span className="sr-only">{label}</span>
    </>
  )
}
